import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { DossierModelService } from './dossier-model.service';
import { DossierModelResolver } from './dossier-model.resolver';

@NgModule({
  imports: [
    BrowserModule,
    RouterModule
  ],
  declarations: [
  ],
  providers: [
    DossierModelService,
    DossierModelResolver
  ]
})
export class DossierModelModule { }